<template>
  <div class="orders-list_container">
    <modal
      ref="loadingModal"
      template="loading"
      title="Aguarde"
      ref-name="loadingModal"
    >
      <p>Salvando alterações.</p>
    </modal>

    <modal
      ref="deleteOrderModal"
      template="question"
      ref-name="deleteOrderModal"
      first-button-text="Cancelar"
      second-button-text="Excluir"
      :close-button-enabled="true"
      @first-cta="closeConfirmOrder"
      @second-cta="confirmDeleteOrder(orders.indexOf(orderForExclusion))"
    >
      <p>
        Deseja excluir a OS {{ orderForExclusion ? orderForExclusion.code_lis : null }}?
      </p>
    </modal>

    <modal
      ref="insertExamAfterTransferred"
      title="Incluir novo exame na ordem de serviço transferida"
      template="question"
      ref-name="insertExamAfterTransferred"
      first-button-text="Cancelar"
      second-button-text="Confirmar"
      :close-button-enabled="true"
      :icon-enabled="false"
      :second-button-disabled="newExamsList.length == 0"
      size="large"
      class="include-exam-after-transferred"
      @first-cta="closeInclusionExamModal()"
      @second-cta="includeExamAfterTransferred(orderEditAfterTransferred)"
    >
      <include-exam-after-transferred :order="orderEditAfterTransferred" />
    </modal>

    <table class="apoio-datatable white-head">
      <colgroup>
        <col class="column-check" />
        <col class="column-date" />
        <col class="column-lis-number" />
        <col class="column-pacient" />
        <col class="column-exams" />
        <col class="column-status" />
        <col class="column-transfer" />
        <col class="column-document" />
        <col class="column-actions" />
        <col class="column-expander" />
      </colgroup>
      <thead>
        <tr class="apoio-datatable__header-line">
          <th
            id="chkOrdersSelectAll"
            class="column-check"
          >
            <div class="styled-checkbox">
              <input
                id="checkOrderSelectAllElement"
                v-model="selectAll"
                type="checkbox"
              />
              <label for="checkOrderSelectAllElement" />
            </div>
            <md-tooltip
              md-delay="400"
              md-direction="right"
            >
              Selecionar todos
            </md-tooltip>
          </th>
          <th
            title="DATA"
            class="sort-column"
            @click.prevent="sortColumn('date')"
          >
            DATA
            <sort-column id="date" />
          </th>
          <th @click="sortColumn('code_lis')">
            <span
              v-if="!toggle.covax"
              title="OS LIS"
              class="sort-column"
            >
              OS LIS
            </span>
            <span
              v-else
              title="Requisition Number"
              class="sort-column covax-label"
            >
              REQUISITION NUMBER
            </span>
            <md-icon
              v-if="!toggle.covax"
              class="icon-status-info"
              @click.stop.prevent
            >
              info_outline
              <md-tooltip
                md-delay="400"
                md-direction="top"
              >
                Número da Ordem de Serviço do sistema do cliente
              </md-tooltip>
            </md-icon>
            <sort-column id="code_lis" />
          </th>
          <th
            title="PACIENTE (ID LIS)"
            colspan="2"
            class="sort-column"
            @click.prevent="sortColumn('patient', 'name')"
          >
            PACIENTE (ID LIS)
            <sort-column id="patient" />
          </th>
          <th
            class="column-exams sort-column"
            title="QTD. EXAMES"
            @click.prevent="sortColumn('exams', 'length')"
          >
            EXAMES
            <sort-column id="exams" />
          </th>
          <th
            class="column-status sort-column"
            title="STATUS"
            @click.prevent="sortColumn('status')"
          >
            STATUS
            <sort-column id="status" />
          </th>
          <th
            class="column-transfer sort-column"
            title="TRANSFERÊNCIA"
            @click.prevent="sortColumn('state')"
          >
            TRANSFERÊNCIA
            <sort-column id="state" />
          </th>
          <th />
          <th
            class="column-actions"
            title="AÇÕES"
          />
          <th />
        </tr>
      </thead>
    </table>

    <table class="apoio-datatable apoio-datatable-alt">
      <colgroup>
        <col class="column-check" />
        <col class="column-date" />
        <col class="column-lis-number" />
        <col class="column-pacient" />
        <col class="column-exams" />
        <col class="column-status" />
        <col class="column-transfer" />
        <col class="column-document" />
        <col class="column-actions" />
        <col class="column-expander" />
      </colgroup>
      <tbody
        v-for="(order, rowIndex) in orders"
        :key="rowIndex"
        :md-item="order"
      >
        <tr
          :id="'order' + order.id"
          :class="[
            { expanded: order.expanded },
            { incorrect: order.status === ORDER_STATUS_ERROR },
          ]"
          class="apoio-datatable__line apoio-datatable-alt"
          @click="toggleActions(order.expanded, order.id)"
        >
          <td class="column-check">
            <div class="styled-checkbox">
              <input
                :id="'chk' + order.id"
                v-model="selected"
                type="checkbox"
                :disabled="!orderCanBeTransmitted(order)"
                :value="order.id"
              />
              <label
                class="list-checkbox"
                :for="'chk' + order.id"
                :disabled="!orderCanBeTransmitted(order)"
              />
            </div>
          </td>
          <td @click.prevent="openOrderDetails(order)">
            <span :title="order.date | formatDate">{{ format(order.date) }}</span>
          </td>
          <td @click.prevent="openOrderDetails(order)">
            <span
              :title="order.code_lis"
              class="os-lis-span"
            >
              {{ order.code_lis }}
            </span>
          </td>
          <td
            colspan="2"
            class="column-pacient"
            @click.prevent="openOrderDetails(order)"
          >
            <span
              :title="concatNameCode(order.patient.name, order.patient.code_origin_lis)"
              class="patient-name-span"
            >
              {{ concatNameCode(order.patient.name, order.patient.code_origin_lis) }}
            </span>
          </td>
          <td
            class="column-exams"
            @click.prevent="openOrderDetails(order)"
          >
            {{ order.exams.length }}
          </td>
          <td
            class="column-status"
            @click.prevent="openOrderDetails(order)"
          >
            <div
              v-if="
                order.status === ORDER_STATUS_ERROR ||
                order.status === ORDER_STATUS_FIXED ||
                order.status === ORDER_STATUS_CORRECT
              "
              class="status-container"
            >
              <span
                :class="
                  'status-symbol order-status--' +
                  $strings.orderStatus[order.status].status
                "
              >
                •
              </span>
              <span
                :class="
                  'status-text order-status--' + $strings.orderStatus[order.status].status
                "
              >
                {{ $strings.orderStatus[order.status].translated }}
              </span>

              <div
                v-if="order.criticism_messages.length > 0"
                class="criticism-messages"
              >
                <md-icon>info</md-icon>
                <md-tooltip
                  md-direction="top"
                  class="custom-tooltip"
                >
                  <ul>
                    <li
                      v-for="(message, index) in order.criticism_messages"
                      :key="'criticism-message-' + index"
                    >
                      {{ message }}
                    </li>
                  </ul>
                </md-tooltip>
              </div>
            </div>
            <div
              v-else
              class="status-container"
            >
              <span :class="'status-symbol'">•</span>
              <span :class="'status-text'">EM VALIDAÇÃO</span>
            </div>
          </td>
          <td
            align="left"
            class="column-transfer"
            @click.prevent="openOrderDetails(order)"
          >
            <button
              v-if="!isOrderTransfering(order)"
              :id="'btn' + order.id"
              class="btn btn-small center order-state-button"
              :class="
                'order-state-button__' +
                $strings.orderStates[order.state].state +
                '--' +
                $strings.orderStatus[order.status || ORDER_STATUS_ERROR].status
              "
              @click.stop.prevent="
                transferIndividualOrder(order.id, $strings.orderStates[order.state].state)
              "
            >
              <md-icon
                class="md-icon orders-list-bar__btn-send__icon md-theme-default"
                :md-src="$strings.orderStates[order.state].buttonIcon"
              />
              {{ $strings.orderStates[order.state].buttonText }}
            </button>
          </td>
          <td
            class="column-document"
            @click.prevent="openOrderDetails(order)"
          >
            <document-icon
              v-if="order.docRequired"
              :is-document-delivered="order.docDelivered"
            />
          </td>
          <td class="column-actions">
            <div v-if="!isTransmited(order.state)">
              <div
                v-if="!isOrderTransfering(order)"
                :id="'order-actions-' + order.id"
                :ref="'order-actions-' + order.id"
                class="order-actions"
              >
                <div
                  v-if="orderCanBeCloned(order)"
                  class="status-icon icon-clone"
                  @click="cloneOrder(order)"
                >
                  <md-tooltip
                    md-delay="400"
                    md-direction="top"
                  >
                    Clonar
                  </md-tooltip>
                </div>
                <div
                  v-if="orderCanBeEdited(order)"
                  class="status-icon icon-edit-alt"
                  @click="$router.push('/orders/edit/' + order.id)"
                >
                  <md-tooltip
                    md-delay="400"
                    md-direction="top"
                  >
                    Editar
                  </md-tooltip>
                </div>
                <div
                  v-else
                  class="status-icon icon-edit-alt"
                >
                  <md-tooltip
                    md-delay="400"
                    md-direction="top"
                  >
                    Edição não permitida
                  </md-tooltip>
                </div>
                <div
                  v-if="!orderCanBeExcluded(order)"
                  class="status-icon icon-delete-alt"
                >
                  <md-tooltip
                    md-delay="400"
                    md-direction="top"
                  >
                    Exclusão
                    <br />
                    não permitida
                  </md-tooltip>
                </div>
                <div
                  v-else
                  class="status-icon icon-delete-alt"
                  @click.capture.stop="openConfirmDeleteOrder(order)"
                >
                  <md-tooltip
                    md-delay="400"
                    md-direction="top"
                  >
                    Excluir
                  </md-tooltip>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="order-actions">
                <div
                  v-if="orderCanBeCloned(order)"
                  class="status-icon icon-clone"
                  @click="cloneOrder(order)"
                >
                  <md-tooltip
                    md-delay="400"
                    md-direction="top"
                  >
                    Clonar
                  </md-tooltip>
                </div>
                <div
                  v-if="
                    !(
                      toggle.exam_inclusion === false ||
                      toggle.exam_inclusion === undefined
                    ) &&
                    order.voucher === false &&
                    !toggle.covax
                  "
                  class="status-icon icon-insert-trans"
                  @click.capture.stop="openInclusionExamModal(order)"
                >
                  <md-tooltip
                    md-delay="400"
                    md-direction="top"
                  >
                    Incluir Exame
                  </md-tooltip>
                </div>
                <div
                  v-else-if="
                    !(
                      toggle.exam_inclusion === false ||
                      toggle.exam_inclusion === undefined
                    ) &&
                    order.voucher === true &&
                    !toggle.covax
                  "
                  class="status-icon icon-insert-trans icon-blocked"
                >
                  <md-tooltip
                    md-delay="400"
                    md-direction="top"
                  >
                    Não é possível incluir exames
                    <br />
                    em vouchers interlaboratoriais
                  </md-tooltip>
                </div>
              </div>
            </div>
          </td>
          <td
            class="open-order-details"
            @click.prevent="openOrderDetails(order)"
          >
            <div v-if="order.loading">
              <spinner class="small" />
            </div>
            <div
              v-if="!order.loading"
              class="status-icon icon-arrow-dropdown-alt"
            >
              <md-tooltip
                md-delay="400"
                md-direction="top"
              >
                Detalhes
              </md-tooltip>
            </div>
          </td>
        </tr>
        <tr
          v-if="order.expanded"
          class="row-details-alt"
        >
          <td
            class="row-details-alt__container"
            colspan="11"
          >
            <order-details :order="order" />
          </td>
        </tr>
      </tbody>
      <tfoot
        v-if="orderLoadingStatus !== 'STATUS_END'"
        class="on-finite"
      >
        <tr>
          <td colspan="11">
            <infinite-loading
              ref="infiniteLoading"
              @infinite="onInfinite()"
            >
              <span slot="no-more" />
              <span slot="no-results" />
              <span slot="spinner">
                <spinner />
              </span>
            </infinite-loading>
          </td>
        </tr>
        <tr
          v-if="totalOrders >= 1000"
          class="on-finite__message-container"
        >
          <td colspan="11">
            <loading-infinite-message
              :break-loading="breakOrdersLoading"
              :update-status-count="getTotalOrder"
            />
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import OrderDetails from '@/components/Orders/OrderDetails'
import Spinner from '@/components/common/Spinner'
import { mapActions, mapGetters } from 'vuex'
import { formatDate } from '@/utils/date-utils'
import { concatNameAndCode } from '@/utils/string-utils'
import ProgressBar from '../common/ProgressBar'
import SortColumn from '@/components/common/SortColumn'
import { setSortation } from '@/utils/sort-columns'
import loadingInfiniteMessage from '@/components/common/LoadingInfiniteMessage'
import notify from '@/api/notification'
import IncludeExamAfterTransferred from './IncludeExamAfterTransferred'
import {
  ORDER_STATE_TRANSMITTED,
  ORDER_STATUS_ERROR,
  ORDER_STATUS_FIXED,
  ORDER_STATUS_CORRECT,
  ORDER_STATE_RECEIVED,
  ORDER_STATE_VALIDATED,
  ORDER_STATE_PENDING_TRANSMISSION,
} from '@/enums'
import DocumentIcon from '../Documents/Laboratory/Flag'

export default {
  name: 'OrdersList',
  components: {
    'infinite-loading': InfiniteLoading,
    spinner: Spinner,
    'order-details': OrderDetails,
    'progress-bar': ProgressBar,
    'sort-column': SortColumn,
    'loading-infinite-message': loadingInfiniteMessage,
    'document-icon': DocumentIcon,
    'include-exam-after-transferred': IncludeExamAfterTransferred,
  },
  props: ['resetSelectListForIndividualTransfer', 'reload'],
  data: () => ({
    ORDER_STATUS_ERROR: ORDER_STATUS_ERROR,
    ORDER_STATE_TRANSMITTED: ORDER_STATE_TRANSMITTED,
    ORDER_STATUS_FIXED: ORDER_STATUS_FIXED,
    ORDER_STATUS_CORRECT: ORDER_STATUS_CORRECT,
    ORDER_STATE_PENDING_TRANSMISSION: ORDER_STATE_PENDING_TRANSMISSION,
    ORDER_STATE_VALIDATED: ORDER_STATE_VALIDATED,
    orderForExclusion: null,
    selected: [],
    transfering: true,
    progress: 0,
    processoValue: 0,
    indexUpdated: null,
    orderForTransfer: null,
    orderForTransferStatus: null,
    columnSortStatusOrders: {
      code_lis: 'asc',
      patient: 'asc',
      date: 'asc',
      exams: 'asc',
      status: 'asc',
      state: 'asc',
    },
    orderTransfering: null,
    orderEditAfterTransferred: null,
    fobiddenExamsTemplates: ['PATERNITY', 'CURVE'],
  }),
  computed: {
    ...mapGetters([
      'orders',
      'orderLoadingStatus',
      'profile',
      'totalOrders',
      'newExamsList',
      'preference',
      'toggle',
    ]),
    selectAll: {
      get: function () {
        if (this.orders.length === 0) {
          return false
        }
        let self = this
        let ordersValidated = this.orders.filter(function (order) {
          return self.orderCanBeTransmitted(order)
        })
        return this.orders
          ? this.selected.length > 0 && this.selected.length === ordersValidated.length
          : false
      },
      set: function (value) {
        var selected = []
        if (value) {
          let self = this
          this.orders.forEach(function (order) {
            if (self.orderCanBeTransmitted(order)) {
              selected.push(order.id)
            }
          })
        }
        this.selected = selected
      },
    },
  },
  watch: {
    orderLoadingStatus: function (newValue) {
      switch (newValue) {
        case 'STATUS_END':
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          break
        case 'STATUS_SUCCESS':
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
          this.setWaitingOSLoadingStatus()
          break
        case 'STATUS_FAILED':
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          break
        case 'STATUS_INITIAL':
          this.clearAllOrderData()
          this.selected = []
          if (this.$refs.infiniteLoading) {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset')
          }
          break
        case 'STATUS_WAITING':
          break
        default:
          break
      }
    },
    selected: function (newValue) {
      this.$emit('update:selected', newValue)
    },
  },
  mounted() {
    this.getMostSentExam()
  },
  methods: {
    ...mapActions([
      'getExamDetails',
      'setOrderClone',
      'getServiceOrder',
      'getServiceOrderDetails',
      'deleteOrder',
      'loadingDetails',
      'clearAllOrderData',
      'setWaitingOSLoadingStatus',
      'performTransferOs',
      'performTransferButton',
      'checkHasBatchOpened',
      'sortOSList',
      'getTotalOrder',
      'breakOrdersLoading',
      'getMostSentExam',
      'openExamCard',
      'includeNewExamAfterTransferred',
      'clearAllNewOrderData',
    ]),
    sortColumn(column, columnChild) {
      this.columnSortStatusOrders[column] = setSortation(
        column,
        columnChild,
        this.columnSortStatusOrders,
        this.sortOSList
      )
      this.pushEventToAnalytics('Ordenação da coluna ' + column)
    },
    format(v) {
      return formatDate(v)
    },
    onInfinite() {
      this.getTotalOrder()
      this.getServiceOrder()
    },
    openConfirmDeleteOrder(order) {
      this.orderForExclusion = order
      this.$refs.deleteOrderModal.open()
    },
    closeConfirmOrder() {
      this.$refs.deleteOrderModal.close()
    },
    confirmDeleteOrder(index) {
      this.deleteOrder(index)
      this.selected = this.selected.filter(e => e !== this.orderForExclusion.id)
      this.closeConfirmOrder()
      this.pushEventToAnalytics('Deletar OS - individual')
    },
    collectAllExamIds() {
      let allIdExams = new Set()
      if (this.orders) {
        for (let i = 0; i < this.orders.length; i++) {
          let os = this.orders[i]
          for (let j = 0; j < os.exams.length; j++) {
            allIdExams.add(os.exams[j].id)
          }
        }
      }
      return allIdExams
    },
    openOrderDetails(order) {
      if (!order.loading) {
        this.loadingDetails(this.orders.indexOf(order))
      }
    },
    orderCanBeTransmitted(order) {
      let orderTransmiting = this.orderTransfering !== order.id
      let orderIncorrectReceived = order.state !== ORDER_STATE_RECEIVED
      let orderIncorrectStatus = order.status !== ORDER_STATUS_ERROR
      let orderInValidatedState = order.state === ORDER_STATE_VALIDATED
      return (
        orderInValidatedState &&
        orderIncorrectStatus &&
        orderIncorrectReceived &&
        orderTransmiting
      )
    },
    orderCanBeExcluded(order) {
      return order.state === ORDER_STATE_VALIDATED || order.state === ORDER_STATUS_FIXED
    },
    orderCanBeEdited(order) {
      return (
        (order.state === ORDER_STATE_VALIDATED && order.voucher === false) ||
        (order.state === ORDER_STATUS_FIXED && order.voucher === false)
      )
    },
    isOrderTransfering(order) {
      return this.orderTransfering === order.id
    },
    concatNameCode(name, code) {
      return concatNameAndCode(name, code)
    },
    transferIndividualOrder(orderById) {
      this.$emit('transferingOsFromPatientView', orderById)
    },
    // TODO: rever funcionalidade da feature toggle 'Ver amostras agrupado por paciente'.
    // transferIndividualOrder (orderById, status) {
    //   if (this.toggle.patientView) {
    //     this.$emit('transferingOsFromPatientView', orderById)
    //   } else {
    //     this.orderForTransfer = orderById
    //     this.orderForTransferStatus = status
    //     this.transformButtonToTransferingbyId(orderById, status)
    //   }
    // },
    startTransferById(orderById) {
      this.performTransferButton(orderById, this.orderForTransferStatus).then(
        response => {
          this.transfering = true
          this.doButtonStyleToTransfering(orderById)

          // Check if there is any Order in State = P (transfering) - if so, reloag the screen
          let isThereTransferingState = this.orders.findIndex(x => x.state === 'P')
          if (isThereTransferingState < 0) {
            this.indexUpdated = this.orders.findIndex(x => x.id === orderById)
            this.orders.splice(this.indexUpdated, 1)
            this.orderTransfering = null
            if (this.orders[this.indexUpdated].status === ORDER_STATUS_CORRECT) {
              this.increaseSummary('corretas')
            } else if (this.orders[this.indexUpdated].status === ORDER_STATUS_ERROR) {
              this.increaseSummary('corrigidas')
            } else if (this.orders[this.indexUpdated].status === ORDER_STATUS_FIXED) {
              this.increaseSummary('erros')
            }
            this.increaseSummary('totalOs')
          } else {
            this.reload()
          }
          if (response) {
            notify({
              title: 'AVISO:',
              message:
                'A ordem de serviço transferida está sendo enviada à lista de validação e estará disponível em breve',
            })
          }
        }
      )
      this.resetSelectListForIndividualTransfer()
    },
    transformButtonToTransferingbyId(orderId, status) {
      if (status === 'VALIDATED') {
        this.startTransferById(orderId)
      }
    },
    increaseSummary(id) {
      var cont = document.getElementById(id).textContent
      var newcont = parseInt(cont) - 1
      document.getElementById(id).innerHTML = newcont
    },
    toggleActions(expanded, id) {
      let container = null
      if (this.$refs['order-actions-' + id]) {
        container = this.$refs['order-actions-' + id][0]
      }
      if (container) {
        if (expanded) {
          this.showActions(container)
        } else {
          this.hideActions(container)
        }
      }
    },
    showActions(container) {
      container.classList.add('actionshowing')
    },
    hideActions(container) {
      container.classList.remove('actionshowing')
    },
    closedTransferModalbyId() {
      this.$refs.transferModalbyId.close()
    },
    startTransferBatchesbyId(order) {
      this.transfering = true
      this.submitOpenBatchs()
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Listagem de OS - Listagem',
        action: 'Transferir OS - Individual',
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName,
      })
    },
    submitOpenBatchs() {
      this.transformButtonToTransferingbyId(
        this.orderForTransfer,
        this.orderForTransferStatus
      )
      this.closedTransferModalbyId()
    },
    doButtonStyleToTransfering(orderId) {
      this.orderTransfering = orderId
    },
    refresh() {
      this.orderEditAfterTransferred = null
      this.clearAllOrderData()
      this.clearAllNewOrderData()
      this.selected = []
      if (this.$refs.infiniteLoading) {
        this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset')
      }
    },
    includeExamAfterTransferred(order) {
      this.closeInclusionExamModal()
      this.$refs.loadingModal.open()
      this.includeNewExamAfterTransferred(order.id).then(response => {
        this.$refs.loadingModal.close()
        this.refresh()
      })
    },
    openInclusionExamModal(order) {
      this.orderEditAfterTransferred = order
      this.$refs.insertExamAfterTransferred.open()
    },
    closeInclusionExamModal() {
      this.$refs.insertExamAfterTransferred.close()
    },
    orderCanBeCloned(order) {
      if (order.status === ORDER_STATUS_ERROR) return false
      return true
    },
    cloneOrder(order) {
      this.setOrderClone(order.id)
      this.$router.push('/orders/new/')
      this.pushCloneInformationToAnalytics(order)
    },
    pushEventToAnalytics(action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Listagem de OS - Listagem',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName,
      })
    },
    pushCloneInformationToAnalytics(order) {
      if (this.profile) {
        this.$analytics.pushAnalyticsEvent('ga-event', {
          category: 'Listagem de OS - Listagem',
          action: 'Clone de OS - clone da OS ID: ' + order.id,
          label: order.exams.length,
          'id-user': this.profile.id,
          'id-lab': this.profile.id_laboratory,
          'name-lab': this.profile.laboratoryName,
        })
      }
    },
    isTransmited(state) {
      return state === ORDER_STATE_TRANSMITTED
    },
  },
}
</script>

<style lang="scss">
@import '../../../static/stylesheets/mixins';

.orders-list {
  &_container {
    margin-top: 2em;

    .order-state-button {
      width: 100%;

      &__FAILED {
        &--CORRECT,
        &--FIXED,
        &--ERROR {
          background-color: #f5a623;
          color: white;
          cursor: not-allowed !important;
          pointer-events: none;
        }
      }

      &__PENDING-TRANSMISSION,
      &__VALIDATED {
        &--CORRECT,
        &--FIXED {
          background-color: #7f1a54;
          color: white;
          &:hover {
            background-color: #691043;
          }
        }

        &--ERROR {
          background-color: #ffffff;
          color: #b8b7bf;
          pointer-events: none;
          cursor: not-allowed !important;
        }
      }

      &__TRANSFERRING {
        &--CORRECT,
        &--FIXED,
        &--ERROR {
          background-color: #ffffff;
          color: #f5a623;
          cursor: progress !important;
          pointer-events: none;
        }
      }

      &__RECEIVED {
        &--CORRECT,
        &--FIXED,
        &--ERROR {
          background-color: #ffffff;
          color: #b8b7bf;
          pointer-events: none;
          cursor: not-allowed !important;
        }
      }
    }

    .status {
      &-container {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
      }

      &-symbol {
        font-family: Roboto, sans-serif;
        font-size: 20px;
        letter-spacing: 1.33px;
        text-transform: uppercase;
        font-weight: 900;
        margin-right: 8.5px;
      }

      &-text {
        font-family: Roboto, sans-serif;
        font-size: 10px;
        letter-spacing: 1.33px;
        text-transform: uppercase;
        font-weight: 900;
      }
    }

    .order-status {
      &--ERROR {
        color: #9c0203;
      }

      &--CORRECT {
        color: #47ba8d;
      }

      &--FIXED {
        color: #f5a623;
      }
    }

    .apoio-datatable {
      margin-top: 0;

      &__line {
        height: 56px;
      }
    }

    .column {
      &-check {
        width: 45px;
        padding: 0 0 0 24px;
      }

      &-date {
        width: 10%;
      }

      &-transfer {
        width: 18%;
        text-align: center;
        padding: 10px 0;
      }

      &-lis-number {
        width: 17%;
      }

      &-date {
        width: 10%;
      }

      &-transfer {
        width: 18%;
        text-align: center;
        padding: 10px 0;
      }

      &-lis-number {
        width: 17%;
      }

      &-actions {
        width: 7%;
        text-align: center;
        padding: 10px 0;
      }

      &-exams {
        width: 2%;
        text-align: center;
        padding: 10px 0;
      }

      &-pacient {
        width: 19%;
      }

      &-document {
        text-align: center;
      }

      &-status {
        width: 5%;
        text-align: center;
      }
    }

    .covax-label {
      max-width: 10.5em;
      display: inline-block;
      text-overflow: ellipsis;
      overflow: hidden;
      width: inherit;
      white-space: nowrap;
      max-height: 1.3em;
    }

    .order-actions {
      display: none;
    }

    .actionshowing {
      display: block !important;
    }

    .notclicable {
      pointer-events: none !important;
    }

    .criticism-messages {
      position: absolute;
      cursor: help;
      right: 10px;

      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        /* IE10 & IE11 CSS styles go here */
        top: -4px;
      }

      .md-icon {
        font-size: 1.6em;
        color: #f5a623;
      }
    }
  }
}

.custom-tooltip {
  ul li {
    list-style-type: circle;
    width: 420px;
    white-space: normal;
  }
  padding: 2% 3%;
  font-size: 12px;
  width: 470px;
}
.column-actions {
  width: 110px !important;
}
</style>
